<template>
  <div>
    <router-view :key="$route.path"></router-view>
    <notifications animation-type="velocity" group="notif" />
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .vue-notification {
    padding: 10px;
    margin: 0 5px 5px;

    font-size: 12px;

    color: #ffffff;
    background: #44A4FC;
    border-left: 5px solid #187FE7;

    &.warn {
      background: #ffb648;
      border-left-color: #f48a06;
    }

    &.error {
      background: #E54D42;
      border-left-color: #B82E24;
    }

    &.success {
      background: #68CD86;
      border-left-color: #42A85F;
    }
  }
  @import 'assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue